import {
  BORDERS,
  COLOR,
  CORNERS,
  FIXED_INDENTS,
  FONTS,
  INDENTS,
  LAYOUT,
} from 'vars/index'

export const InputFonts = {
  Body3: FONTS.Body3,
  Body4: FONTS.Body4,
  Caption2: FONTS.Caption2,
  FontSm: FONTS.FontSm,
  FontXs: FONTS.FontXs,
} as const
export type InputFonts = (typeof InputFonts)[keyof typeof InputFonts]

export const InputFontColors = {
  TEXT_ICON_PRIMARY: COLOR.TEXT_ICON_PRIMARY,
  TEXT_ICON_SECONDARY: COLOR.TEXT_ICON_SECONDARY,
  TEXT_ICON_TERTIARY: COLOR.TEXT_ICON_TERTIARY,
} as const
export type InputFontColors =
  (typeof InputFontColors)[keyof typeof InputFontColors]

export const InputCaretColors = {
  TEXT_ICON_SECONDARY: COLOR.TEXT_ICON_SECONDARY,
} as const
export type InputCaretColors =
  (typeof InputCaretColors)[keyof typeof InputCaretColors]

export const InputCorners = {
  CORNERS_0: CORNERS.CORNERS_0,
  CORNERS_10: CORNERS.CORNERS_10,
} as const
export type InputCorners = (typeof InputCorners)[keyof typeof InputCorners]

export const InputBorders = {
  BORDER_0: BORDERS.BORDER_0,
  BORDER_10: BORDERS.BORDER_10,
} as const
export type InputBorders = (typeof InputBorders)[keyof typeof InputBorders]

export const InputBorderColors = {
  SURFACE_OPACITY_LIGHT_10: COLOR.SURFACE_OPACITY_LIGHT_10,
  SURFACE_OPACITY_LIGHT_15: COLOR.SURFACE_OPACITY_LIGHT_15,
  SURFACE_OPACITY_LIGHT_20: COLOR.SURFACE_OPACITY_LIGHT_20,
  ADDITIONAL_RED_2: COLOR.ADDITIONAL_RED_2,
} as const
export type InputBorderColors =
  (typeof InputBorderColors)[keyof typeof InputBorderColors]

export const InputBackgroundColors = {
  SURFACE_OPACITY_LIGHT_10: COLOR.SURFACE_OPACITY_LIGHT_10,
  SURFACE_OPACITY_LIGHT_15: COLOR.SURFACE_OPACITY_LIGHT_15,
  SURFACE_OPACITY_LIGHT_20: COLOR.SURFACE_OPACITY_LIGHT_20,
} as const
export type InputBackgroundColors =
  (typeof InputBackgroundColors)[keyof typeof InputBackgroundColors]

export const InputPaddings = {
  SIZE_0: [
    INDENTS.INDENT_0,
    INDENTS.INDENT_0,
    INDENTS.INDENT_0,
    INDENTS.INDENT_0,
  ],
  SIZE_10: [
    INDENTS.INDENT_30,
    INDENTS.INDENT_60,
    INDENTS.INDENT_30,
    INDENTS.INDENT_60,
  ],
  SIZE_20: [
    INDENTS.INDENT_20,
    INDENTS.INDENT_40,
    INDENTS.INDENT_20,
    INDENTS.INDENT_40,
  ],
  SIZE_30: [
    INDENTS.INDENT_20,
    INDENTS.INDENT_100,
    INDENTS.INDENT_20,
    INDENTS.INDENT_100,
  ],
  SIZE_40: [
    FIXED_INDENTS.INDENT_40,
    FIXED_INDENTS.INDENT_140,
    FIXED_INDENTS.INDENT_40,
    FIXED_INDENTS.INDENT_100,
  ],
  SIZE_50: [
    FIXED_INDENTS.INDENT_70,
    LAYOUT.HorizontalPaddings,
    FIXED_INDENTS.INDENT_70,
  ],
  SIZE_60: [FIXED_INDENTS.INDENT_40, FIXED_INDENTS.INDENT_120],
}
export const InputPaddingsAdaptive = {
  SIZE_10: '--input-paddings-size-70',
} as const
export type InputPaddingsAdaptive =
  (typeof InputPaddingsAdaptive)[keyof typeof InputPaddingsAdaptive]
export type InputPadding = (typeof InputPaddings)[keyof typeof InputPaddings]

export const InputHeight = {
  SIZE_10: '--input-height-size-10',
  SIZE_20: '--input-height-size-20',
  SIZE_30: '--input-height-size-30',
} as const
export type InputHeight = (typeof InputHeight)[keyof typeof InputHeight]

export const InputMargins = {
  SIZE_10: [
    FIXED_INDENTS.INDENT_70,
    LAYOUT.HorizontalPaddings,
    FIXED_INDENTS.INDENT_70,
  ],
}
export type InputMargin = (typeof InputMargins)[keyof typeof InputMargins]

export const InputActionButtonPosition = {
  Left: 'Left',
  Right: 'Right',
} as const
export type InputActionButtonPosition =
  (typeof InputActionButtonPosition)[keyof typeof InputActionButtonPosition]

export const InputActionButtonIndent = {
  INDENT_40: INDENTS.INDENT_40,
  INDENT_60: INDENTS.INDENT_60,
} as const
export type InputActionButtonIndent =
  (typeof InputActionButtonIndent)[keyof typeof InputActionButtonIndent]

export const InputActionButtonIndentAdaptive = {
  SIZE_10: '--input-action-button-indent-size-10',
} as const
export type InputActionButtonIndentAdaptive =
  (typeof InputActionButtonIndentAdaptive)[keyof typeof InputActionButtonIndentAdaptive]

export const InputNames = {
  Password: 'password',
  Phone: 'phone',
  Username: 'username',
  Profile: 'profile',
  Search: 'search',
} as const
export type InputNames = (typeof InputNames)[keyof typeof InputNames]
